import { useRouter } from "next/router";
import { Footer } from "@nju/feature-portal-footer";
import { Header } from "@nju/feature-portal-header";
import { portalRoutes } from "@nju/routes";
import { BlockContent, GeneralErrorNotification, LayoutWrapper } from "@nju/ui";
import { ClientSideOnly } from "../components/ClientSideRenderer";

export default function OrderInProgress() {
  const router = useRouter();

  return (
    <LayoutWrapper>
      <Header />
      <ClientSideOnly>
        <BlockContent grid="default" spacing="xl" tone="none">
          <GeneralErrorNotification
            callback={() => {
              router.replace(portalRoutes.mojeKonto.index.get());
            }}
            copy="powrót"
            description="Jesteś już w trakcie zamawiania usługi. Aby zamówić kolejną, dokończ poprzedni zakup."
            icon="times-circle"
            title="nie wszystko na raz"
          />
        </BlockContent>
      </ClientSideOnly>
      <Footer />
    </LayoutWrapper>
  );
}
